export default __webpack_public_path__ + "static/media/instagram.aac72a87.svg";